/**
 * Direction of a route change for the View Transitions API (CSS: `:active-view-transition-type(push|pop|tab)`):
 * deeper path within the same tab → push (slide in from the right), shallower → pop, other tab → crossfade.
 * Search-only changes (filters, segmented tabs) and reduced motion → no transition.
 * @param {{ fromLocation?: { pathname: string }, toLocation: { pathname: string }, pathChanged: boolean }} info
 * @returns {string[] | false}
 */
export function transitionTypes({ fromLocation, toLocation, pathChanged }) {
  if (!fromLocation || !pathChanged) return false;
  if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return false;
  const from = segments(fromLocation.pathname);
  const to = segments(toLocation.pathname);
  if (from[0] !== to[0]) return ['tab'];
  if (to.length > from.length) return ['push'];
  if (to.length < from.length) return ['pop'];
  return ['tab'];
}

/** @param {string} pathname */
const segments = (pathname) => pathname.split('/').filter(Boolean);
